import { render, staticRenderFns } from "./SavingSuccess.vue?vue&type=template&id=a5a057f4&"
import script from "./SavingSuccess.vue?vue&type=script&lang=js&"
export * from "./SavingSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports